import React from 'react';
import Avatar from '@material-ui/core/Avatar';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';
import ListSubheader from '@material-ui/core/ListSubheader';
import TransferIcon from '@material-ui/icons/AirportShuttle';
import { _T } from 'appI18n';
import { useListSubheaderStyles } from './styles';
import moment from 'moment';
export default function TransferDescription({ services }) {
    const subhClasses = useListSubheaderStyles();
    return React.createElement(List, { subheader: React.createElement(ListSubheader, { className: subhClasses.root, disableGutters: true }, _T.COMMON_TRANSFERS) }, services.map((x, i) => React.createElement(ListItem, { disableGutters: true, key: i },
        React.createElement(ListItemAvatar, null,
            React.createElement(Avatar, null,
                React.createElement(TransferIcon, null))),
        React.createElement(ListItemText, { primary: `${x.name} / ${x.transferType.name}`, secondary: `${moment(x.beginDate).format("L")} (${moment(x.beginDate).format("dd")})` }))));
}
